import { z } from 'zod'

export const STRATALYST_RESPONDENT_OPS_SHELL_CONTRACT_VERSION = '1.0.0' as const
export const stratalystRespondentOpsShellResponseSchema = z.unknown()
export type StratalystRespondentOpsShellResponse = z.infer<typeof stratalystRespondentOpsShellResponseSchema>
